import {addParamsToUrl, athubAxios} from '../../util'
import {COMMON_SERVER} from '../server'

const CommonApi = {

    getIdSy() {
        let url = `${COMMON_SERVER}/snowFlake/getIdSy`;
        let promise = new Promise((resolve, reject) => {
            athubAxios.get(url).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.data);
                } else {
                    reject(responseBody.data.message);
                }
            })
        });
        return promise;
    },

    getIdsSy() {
        let url = `${COMMON_SERVER}/snowFlake/getIdsSy`;
        let promise = new Promise((resolve, reject) => {
            athubAxios.get(url).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.data);
                } else {
                    reject(responseBody.data.message);
                }
            })
        });
        return promise;
    },

    //据部门编号集合查询数据中心
    getRoomsByDeptIds(deptIds) {
        return new Promise((resolve, reject) => {
            athubAxios.get(`${COMMON_SERVER}/sys/room/getRoomsByDepts?deptIds=${deptIds}`).then((res) => {
                if (res.status == 200) {
                    resolve(res.data.data);
                } else {
                    reject('获取数据中心信息失败');
                }
            }, (error) => {
                reject(error);
            });
        });
    },

    //获取部门列表(部门下若有数据中心状态为RUNNING则列出)
    getRunningDeptListByAuth() {
        return new Promise((resolve, reject) => {
            athubAxios.post(COMMON_SERVER + '/dept/getRunningDeptListByAuthSites?orgid=' + localStorage.getItem("authorg") + '&sites=' + localStorage.getItem("authsites"), {}
            ).then((responseBody) => {
                if (responseBody.status == 200) {
                    return resolve(responseBody.data.data);
                }
            }).catch(error => {
                reject(error);
            });
        });
    },

    //获取部门列表(部门下若有数据中心状态为RUNNING则列出)
    getRunningDeptList() {
        return new Promise((resolve, reject) => {
            athubAxios.post(COMMON_SERVER + '/dept/getRunningDeptListByAuthSites?orgid=' + localStorage.getItem("authorg"), {}
            ).then((responseBody) => {
                if (responseBody.status == 200) {
                    return resolve(responseBody.data.data);
                }
            }).catch(error => {
                reject(error);
            });
        });
    },

    insertTrackInfo(ownerid, ownertable, docType, description, attachment, userid) {
        let params = {
            'ownerid': ownerid,
            'ownertable': ownertable,
            'docType': docType,
            'description': description,
            'attachment': attachment,
            'userid': userid,
            'ownerTable':'TRACKINFO',
            'appId': 'WEB',
            'token': localStorage.getItem("token"),
        }
        return athubAxios.postByMultipartForm(COMMON_SERVER + '/trackinfo/saveAndUploadTrack', params);
    },

    getTrackInfoList(ownerId, ownerTable) {
        let params = {
            'ownerid': ownerId,
            'ownertable': ownerTable,
            'appId': 'WEB',
            'token': localStorage.getItem("token"),
        }
        return athubAxios.postByMultipartForm(COMMON_SERVER + '/trackinfo/selectTrackInfoAndFile', params);
    },

    getDataCenterById(id) {
        return new Promise((resolve, reject) => {
            athubAxios.get(addParamsToUrl(`${COMMON_SERVER}/sys/room/getDcnumInfoById`, {id: id})).then(function(response) {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject('查询数据中心失败');
                }
            }, function(error) {
                reject(error);
            });
        });
    },
}

export default CommonApi;
